<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <v-card class="pa-4">
      <div class="d-flex align-center mb-6">
        <div class="text-h6">Adicionar assinatura</div>

        <v-spacer />

        <v-btn color="primary" :disabled="loading" small icon @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <section class="mb-8">
        <v-form v-model="valid" ref="form" autocomplete="off">
          <div @keypress.enter.prevent="submit()">
            <v-menu
              v-model="menuValidate"
              transition="scale-transition"
              max-width="18.125rem"
              min-width="auto"
              :close-on-content-click="false"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="Validade"
                  append-icon="mdi-calendar"
                  class="mb-4"
                  readonly
                  :value="_formattedValidate"
                  :rules="_rules"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>

              <v-date-picker
                v-model="form.validate"
                locale="pt-BR"
                class="mb-4"
                no-title
                :min="_minDate"
                @input="menuValidate = false"
              />
            </v-menu>

            <v-text-field
              v-model="form.value"
              v-money="_money"
              id="value"
              class="mb-4"
              label="Valor"
              :rules="_rules"
            />

            <v-textarea
              v-model="form.description"
              label="Descrição"
              placeholder="Digite a descrição"
              class="mb-4"
              :rules="_rules"
              outlined
              auto-grow
            />
          </div>
        </v-form>
      </section>

      <div class="d-flex justify-end">
        <v-btn
          v-if="!loading"
          class="text-none rounded-lg mr-2"
          :loading="loading"
          text
          @click="close()"
        >
          Cancelar
        </v-btn>

        <v-btn
          class="text-none rounded-lg"
          color="primary"
          :loading="loading"
          depressed
          @click="submit()"
        >
          Confirmar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { request } from "@/services";
import { parseNumber } from "@/utils";
import { VMoney } from "v-money";
const moment = require("moment");

export default {
  name: "CancelSignature",

  directives: {
    money: VMoney,
  },

  data() {
    return {
      loading: false,
      dialog: false,
      valid: false,
      menuValidate: false,
      form: {
        validate: "",
        value: "",
        description: "",
      },
    };
  },

  computed: {
    _money() {
      return {
        decimal: ",",
        thousands: ".",
        precision: 2,
      };
    },

    _minDate() {
      const today = new Date();
      today.setDate(today.getDate());

      return today.toISOString().substr(0, 10);
    },

    _rules() {
      return [(v) => !!v || "Campo Obrigatório"];
    },

    _formattedValidate() {
      if (!this.form.validate) return "";

      return moment(this.form.validate).format("DD/MM/YYYY");
    },
  },

  methods: {
    async submit() {
      try {
        this.loading = true;

        const payload = {
          method: "giveCreatorsSubscriptions",
          userID: this.$route.params.id,
          dataValidade: this.form.validate,
          valor: parseNumber(this.form.value),
          descricao: this.form.description,
        };

        await request(payload);

        this.handleAlert("Assinatura aplicada com sucesso", "success");

        this.$emit("update");
        this.close();
      } catch (error) {
        this.handleAlert(error.data.message, "error");
      } finally {
        this.loading = false;
      }
    },

    handleAlert(title, type) {
      this.$root.$emit("alert", { title, type });
    },

    open() {
      this.dialog = true;

      if (this.$refs.form) {
        this.$refs.form.reset();

        this.$nextTick(() => {
          document.getElementById("value").value = "0,00";
        });
      }
    },

    close() {
      this.dialog = false;
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
